export const province = [
    "Agrigento", "Alessandria", "Ancona", "Aosta", "Arezzo", "Ascoli Piceno", "Asti",
    "Avellino", "Bari", "Barletta-Andria-Trani", "Belluno", "Benevento", "Bergamo",
    "Biella", "Bologna", "Bolzano", "Brescia", "Brindisi", "Cagliari", "Caltanissetta",
    "Campobasso", "Caserta", "Catania", "Catanzaro", "Chieti", "Como", "Cosenza", "Cremona",
    "Crotone", "Cuneo", "Enna", "Fermo", "Ferrara", "Firenze", "Foggia", "Forlì-Cesena",
    "Genova", "Gorizia", "Grosseto", "Imperia", "Isernia", "L'Aquila", "La Spezia", "Latina",
    "Lecce", "Lecco", "Livorno", "Lodi", "Lucca", "Macerata", "Mantova", "Massa-Carrara",
    "Matera", "Messina", "Milano", "Modena", "Napoli", "Novara", "Nuoro", "Oristano", "Padova",
    "Palermo", "Parma", "Pavia", "Perugia", "Pesaro e Urbino", "Pescara", "Piacenza", "Pisa",
    "Potenza", "Prato", "Ragusa", "Ravenna", "Reggio Calabria", "Reggio Emilia", "Rieti",
    "Roma", "Rovigo", "Salerno", "Savona", "Siena", "Siracusa", "Sondrio", "Taranto", "Teramo",
    "Terni", "Torino", "Trapani", "Trento", "Treviso", "Vibo Valentia", "Vicenza", "Viterbo"
];

// Array con province e relative sigle
export const daSiglaAProvincia = {
    "AG": "Agrigento",
    "AL": "Alessandria",
    "AN": "Ancona",
    "AO": "Aosta",
    "AR": "Arezzo",
    "AP": "Ascoli Piceno",
    "AT": "Asti",
    "AV": "Avellino",
    "BA": "Bari",
    "BT": "Barletta-Andria-Trani",
    "BL": "Belluno",
    "BN": "Benevento",
    "BG": "Bergamo",
    "BI": "Biella",
    "BO": "Bologna",
    "BZ": "Bolzano",
    "BS": "Brescia",
    "BR": "Brindisi",
    "CA": "Cagliari",
    "CL": "Caltanissetta",
    "CB": "Campobasso",
    "CE": "Caserta",
    "CT": "Catania",
    "CZ": "Catanzaro",
    "CH": "Chieti",
    "CO": "Como",
    "CS": "Cosenza",
    "CR": "Cremona",
    "KR": "Crotone",
    "CN": "Cuneo",
    "EN": "Enna",
    "FM": "Fermo",
    "FE": "Ferrara",
    "FI": "Firenze",
    "FG": "Foggia",
    "FC": "Forlì-Cesena",
    "GE": "Genova",
    "GO": "Gorizia",
    "GR": "Grosseto",
    "IM": "Imperia",
    "IS": "Isernia",
    "AQ": "L'Aquila",
    "SP": "La Spezia",
    "LT": "Latina",
    "LE": "Lecce",
    "LC": "Lecco",
    "LI": "Livorno",
    "LO": "Lodi",
    "LU": "Lucca",
    "MC": "Macerata",
    "MN": "Mantova",
    "MS": "Massa-Carrara",
    "MT": "Matera",
    "ME": "Messina",
    "MI": "Milano",
    "MO": "Modena",
    "NA": "Napoli",
    "NO": "Novara",
    "NU": "Nuoro",
    "OR": "Oristano",
    "PD": "Padova",
    "PA": "Palermo",
    "PR": "Parma",
    "PV": "Pavia",
    "PG": "Perugia",
    "PU": "Pesaro e Urbino",
    "PE": "Pescara",
    "PC": "Piacenza",
    "PI": "Pisa",
    "PZ": "Potenza",
    "PO": "Prato",
    "RG": "Ragusa",
    "RA": "Ravenna",
    "RC": "Reggio Calabria",
    "RE": "Reggio Emilia",
    "RI": "Rieti",
    "RM": "Roma",
    "RO": "Rovigo",
    "SA": "Salerno",
    "SV": "Savona",
    "SI": "Siena",
    "SR": "Siracusa",
    "SO": "Sondrio",
    "TA": "Taranto",
    "TE": "Teramo",
    "TR": "Terni",
    "TO": "Torino",
    "TP": "Trapani",
    "TN": "Trento",
    "TV": "Treviso",
    "VV": "Vibo Valentia",
    "VI": "Vicenza",
    "VT": "Viterbo"
};

export const daProvinciaASigla = {
    "Agrigento": "AG",
    "Alessandria": "AL",
    "Ancona": "AN",
    "Aosta": "AO",
    "Arezzo": "AR",
    "Ascoli Piceno": "AP",
    "Asti": "AT",
    "Avellino": "AV",
    "Bari": "BA",
    "Barletta-Andria-Trani": "BT",
    "Belluno": "BL",
    "Benevento": "BN",
    "Bergamo": "BG",
    "Biella": "BI",
    "Bologna": "BO",
    "Bolzano": "BZ",
    "Brescia": "BS",
    "Brindisi": "BR",
    "Cagliari": "CA",
    "Caltanissetta": "CL",
    "Campobasso": "CB",
    "Caserta": "CE",
    "Catania": "CT",
    "Catanzaro": "CZ",
    "Chieti": "CH",
    "Como": "CO",
    "Cosenza": "CS",
    "Cremona": "CR",
    "Crotone": "KR",
    "Cuneo": "CN",
    "Enna": "EN",
    "Fermo": "FM",
    "Ferrara": "FE",
    "Firenze": "FI",
    "Foggia": "FG",
    "Forlì-Cesena": "FC",
    "Genova": "GE",
    "Gorizia": "GO",
    "Grosseto": "GR",
    "Imperia": "IM",
    "Isernia": "IS",
    "L'Aquila": "AQ",
    "La Spezia": "SP",
    "Latina": "LT",
    "Lecce": "LE",
    "Lecco": "LC",
    "Livorno": "LI",
    "Lodi": "LO",
    "Lucca": "LU",
    "Macerata": "MC",
    "Mantova": "MN",
    "Massa-Carrara": "MS",
    "Matera": "MT",
    "Messina": "ME",
    "Milano": "MI",
    "Modena": "MO",
    "Napoli": "NA",
    "Novara": "NO",
    "Nuoro": "NU",
    "Oristano": "OR",
    "Padova": "PD",
    "Palermo": "PA",
    "Parma": "PR",
    "Pavia": "PV",
    "Perugia": "PG",
    "Pesaro e Urbino": "PU",
    "Pescara": "PE",
    "Piacenza": "PC",
    "Pisa": "PI",
    "Potenza": "PZ",
    "Prato": "PO",
    "Ragusa": "RG",
    "Ravenna": "RA",
    "Reggio Calabria": "RC",
    "Reggio Emilia": "RE",
    "Rieti": "RI",
    "Roma": "RM",
    "Rovigo": "RO",
    "Salerno": "SA",
    "Savona": "SV",
    "Siena": "SI",
    "Siracusa": "SR",
    "Sondrio": "SO",
    "Taranto": "TA",
    "Teramo": "TE",
    "Terni": "TR",
    "Torino": "TO",
    "Trapani": "TP",
    "Trento": "TN",
    "Treviso": "TV",
    "Vibo Valentia": "VV",
    "Vicenza": "VI",
    "Viterbo": "VT"
};